// Code review - In Progress
// Documentation - In Progress
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import FileUpload from "../ReusableComponents/FileUpload";
import { useNavigate } from "react-router-dom";
import Loader from "../ReusableComponents/Loader";

const PartnerRegistration = forwardRef(({ closePopup }, ref) => {
  const navigate = useNavigate();
  const [bindContactNoAndEmailDatas, setBindContactNoAndEmailDatas] = useState(
    []
  );
  const [partnerBulkUploadData, setPartnerBulkUploadData] = useState("");
  const [partnerBulkUploadDataNew, setPartnerBulkUploadDataNew] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [partnerFields, setPartnerFields] = useState({
    partnerId: "PTNR",
    partnerName: "",
    address: "",
    country: "77",
    state: "",
    city: "",
    type: "VCP",
    pinCode: "",
    date: new Date(),
    firstName: null,
    LastName: "",
    showImage: "",
    designation: "",
    contactNumber: "",
    email: "",
    gst: "",
  });

  const [partnerFieldsError, setPartnerFieldsError] = useState({
    partnerIdError: "",
    partnerNameError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    pinCodeError: "",
    dateError: "",
    firstNameError: "",
    LastNameError: "",
    designationError: "",
    contactNumberError: "",
    emailError: "",
    showImageError: "",
    gstError: ""
  });
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setPartnerFields({ ...partnerFields, date: formattedDate });
    };

    fetchData();
  }, []);
  useEffect(() => {
    BindPartnerGridData();
  }, []);
  const BindPartnerGridData = async () => {
    const response = await BindAPI("PartnerAPI/BindPartner");
    setBindContactNoAndEmailDatas(response.data.Table2);
  };
  const handlePartnerFieldsChange = (value, name) => {
    setPartnerFields({
      ...partnerFields,
      [name]: value,
    });
  };

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);

  // view details end

  useEffect(() => {
    const fetchData = async () => {
      binddrpCoutrydata();
      // bindDrpsDesignationData();
    };
    fetchData();
  }, []);
  const binddrpCoutrydata = async () => {
    try {
      const bindCountrydatadrp = await BindAPI("CountryAPI/BindCountry");
      if (bindCountrydatadrp.data.Table.length > 0) {
        const countryDD = bindCountrydatadrp.data.Table.map((m) => ({
          value: m.MstCountryId,
          label: m.CountryName_en,
        }));
        setCountryBindDD(countryDD);
      } else {
        setCountryBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };


  const cancel = () => {
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    navigate("/");
    closePopup();
    clear();
    window.location.reload();
  };
  const clear = () => {

    setPartnerFields({
      partnerId: "PTNR",
      partnerName: "",
      address: "",
      country: "1",
      state: "",
      city: "",
      type: "VCP",
      pinCode: "",
      date: new Date(),
      firstName: "",
      LastName: "",
      showImage: "",
      designation: "",
      contactNumber: "",
      email: "",
      gst: "",
    });
    setPartnerFieldsError({
      partnerIdError: "",
      partnerNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      pinCodeError: "",
      dateError: "",
      firstNameError: "",
      LastNameError: "",
      designationError: "",
      contactNumberError: "",
      emailError: "",
      showImageError: "",
      gstError: "",
    });
  };

  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setPartnerFields({
      ...partnerFields,
      showImage: showImage.fileUrl || "", // This will set to showImage if it's truthy, else ""
    });

    // Reset any error related to showImage
    setPartnerFieldsError({ ...partnerFieldsError, showImageError: "" });
  };
  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const [designationBindDD, setDesignationBindDD] = useState([]);
  const trueFunction = () => {
    setSubmitBtnDisabled(false); // Call to re-enable the submit button
  };
  const handleSubmit = async (items, flag) => {
    debugger
    setIsLoading(true);
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...partnerFieldsError,
        partnerNameError:
          partnerFields.partnerName && partnerFields.partnerName.length > 0
            ? ""
            : partnerFields.partnerName.length < 3
              ? "Minimum 3 characters required"
              : partnerFields.partnerName.length > 200
                ? "Maximum 200 characters allowed"
                : "Enter Partner Name",
        addressError:
          partnerFields.address && partnerFields.address.trim().length > 0

            ? ""
            : "Enter full address",
        countryError: partnerFields.country ? "" : "Select Country",

        firstNameError:
          partnerFields.firstName && partnerFields.firstName.length > 0
            ? ""
            : partnerFields.firstName.length < 2
              ? "Minimum 2 characters required"
              : partnerFields.firstName.length > 100
                ? "Maximum 100 characters allowed"
                : "Enter First Name",
        LastNameError:
          partnerFields.LastName && partnerFields.LastName.trim().length > 0
            ? ""
            : partnerFields.LastName.trim().length > 100
              ? "Maximum 100 characters allowed"
              : "Enter Last Name",

        contactNumberError:
          partnerFields.contactNumber && partnerFields.contactNumber.length > 0
            ? ""
            : "Enter Contact Number",
        emailError:
          partnerFields.email.length > 0

            ? !updateScreenTitle &&
              bindContactNoAndEmailDatas.find(
                (x) =>
                  x.UserEmail.toLowerCase() ===
                  partnerFields.email.toLowerCase()
              )
              ? "Email Address already available"
              : ""
            : "Enter Email",

        designationError:
          partnerFields.designation && partnerFields.designation.trim().length > 0
            ? ""
            : "Enter Designation",
        gstError:
          partnerFields.gst && partnerFields.gst.trim().length > 0
            ? ""
            : "Enter GST"
      };
      setPartnerFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (!isFormValid) {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return; // Prevent popup close or submission
      }
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const partnerPayload = [
          {
            mstPartnerId: 0,
            partnerName: partnerFields.partnerName,
            partnerId: partnerFields.partnerId,
            mstCountryId: parseInt(partnerFields.country) || 0,
            state: partnerFields.state ? partnerFields.state : null,
            location: partnerFields.city ? partnerFields.city : null,
            partnerAddress: partnerFields.address,
            partnerPincode: partnerFields.pinCode || null,
            partnerLogo: partnerFields.showImage,
            partnerContactPersonFName: partnerFields.firstName,
            partnerContactPersonLName: partnerFields.LastName,
            partnerContactPersonDesignation: partnerFields.designation,
            partnerMobileNumber: partnerFields.contactNumber,
            partnerEmailId: partnerFields.email,
            partnerDate: partnerFields.date,
            encryptedPwd: "",
            type: partnerFields.type,
            gst: partnerFields.gst,
            partnerDate: partnerFields.date,
            bulkUpload: JSON.stringify(partnerBulkUploadDataNew),
            createdby: 0,
            flag: flag,
          },
        ];

        const response = await IUDAPI(partnerPayload, "PartnerAPI/IUDPartner");

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Assessee Registration Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Assessee Registration 👎", {
              duration: 2000,
              position: "top-center",
            });
            // Don't close popup on error
          }
        }
      }
    }
  };
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleSubmit(0, 1);
      setSubmitBtnDisabled();
    },
    childCancelFunction() {
      cancel();
    },
  }));

  useEffect(() => {
    const getMenuTableDatas = async () => {
      let rightsResponse;
      try {
        rightsResponse = await BindAPI(
          "RoleVsCapabilityAPI/BindRoleVsCapability"
        );
        const response = await BindAPI("RoleVsCapabilityAPI/BindScreenMenu");
        const organizedData = {};

        const processMenuData = (menuHeadingId) => {
          const filteredData = response.data.Table.filter(
            (item) => item.MstMenuHeadingId === menuHeadingId
          );

          const menuList = {};

          filteredData.forEach((item) => {
            if (!menuList[item.MenuName]) {
              menuList[item.MenuName] = {
                MenuName: item.MenuName,
                MstMenuId: item.MainMenuId ? null : item.MstMenuId,
                MainMenuId: item.MainMenuId,
                MstMenuHeadingId: item.MstMenuHeadingId,
                checked:
                  item.MainMenuId && item.SubMenu && item.SubMenu.length > 0
                    ? null
                    : [],
                SubMenu: [],
                View: item.View,
                Add: item.Add,
                Edit: item.Edit,
                Delete: item.Delete,
                Inactive: item.Inactive,
                Service: item.Service,
              };
            }

            const submenuFiltered = response.data.Table.filter(
              (subItem) =>
                subItem.MenuName === item.MenuName &&
                subItem.MainMenuId &&
                subItem.MstMenuHeadingId === menuHeadingId
            ).map((subItem) => ({
              SubMenu: subItem.SubMenu,
              MstMenuId: subItem.MstMenuId,
              MainMenuId: subItem.MainMenuId,
              MstMenuHeadingId: subItem.MstMenuHeadingId,
              checked: [],
              View: item.View,
              Add: item.Add,
              Edit: item.Edit,
              Delete: item.Delete,
              Inactive: item.Inactive,
              Service: item.Service,
            }));

            const arr = rightsResponse.data.Table.filter(
              (e) =>
                e.MstMenuId == menuList[item.MenuName].MstMenuId &&
                e.MstRoleId == 3
            );
            const checkedData =
              arr.length > 0
                ? {
                  add: arr[0].AddPermission === 1,
                  view: arr[0].ViewPermission === 1,
                  inActive: arr[0].BlockPermission === 1,
                  delete: arr[0].DeletePermission === 1,
                  edit: arr[0].ModifyPermission === 1,
                  service: arr[0].ProvideServicePermission === 1,
                  title:
                    arr[0].AddPermission === 1 &&
                    arr[0].ViewPermission === 1 &&
                    arr[0].BlockPermission === 1 &&
                    arr[0].DeletePermission === 1 &&
                    arr[0].ModifyPermission === 1 &&
                    arr[0].ProvideServicePermission === 1,
                }
                : {
                  title: false,
                  add: false,
                  view: false,
                  inActive: false,
                  delete: false,
                  edit: false,
                  service: false,
                };
            if (menuList[item.MenuName].checked !== null) {
              menuList[item.MenuName].checked.push(checkedData);
            }

            submenuFiltered.forEach((subItem) => {
              const subMenuItemExists = menuList[item.MenuName].SubMenu.some(
                (existingSubMenu) => existingSubMenu.SubMenu == subItem.SubMenu
              );
              if (!subMenuItemExists) {
                const arr = rightsResponse.data.Table.filter(
                  (e) => e.MstMenuId == subItem.MstMenuId && e.MstRoleId == 3
                );
                subItem.checked =
                  arr.length > 0
                    ? {
                      add: arr[0].AddPermission === 1,
                      view: arr[0].ViewPermission === 1,
                      inActive: arr[0].BlockPermission === 1,
                      delete: arr[0].DeletePermission === 1,
                      edit: arr[0].ModifyPermission === 1,
                      service: arr[0].ProvideServicePermission === 1,
                      title:
                        arr[0].AddPermission === 1 &&
                        arr[0].ViewPermission === 1 &&
                        arr[0].BlockPermission === 1 &&
                        arr[0].DeletePermission === 1 &&
                        arr[0].ModifyPermission === 1 &&
                        arr[0].ProvideServicePermission === 1,
                    }
                    : {
                      title: false,
                      add: false,
                      view: false,
                      inActive: false,
                      delete: false,
                      edit: false,
                      service: false,
                    };

                if (!subMenuItemExists) {
                  menuList[item.MenuName].SubMenu.push(subItem);
                }
              }
            });
          });

          return Object.values(menuList);
        };

        organizedData.Dashboard = processMenuData(1); // Dashboard
        organizedData.Administrator = processMenuData(2); // Administrator
        organizedData.Analyst = processMenuData(3); // Transaction
        organizedData.Supplier = processMenuData(4); // Reports

        setPartnerBulkUploadData(organizedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getMenuTableDatas();
  }, [partnerFields.email]);

  const createdBy = sessionStorage.getItem("createdBy");

  const convertOrganizedMenuData = (menuData, handleRoleChange) => {
    const convertedMenuData = [];

    Object.keys(menuData).forEach((key) => {
      menuData[key].forEach((item) => {
        // Process main menu if MstMenuId is not null
        if (item.MstMenuId !== null) {
          convertedMenuData.push({
            MstRoleId: handleRoleChange,
            MstMenuHeadingId: item.MstMenuHeadingId,
            MstMenuId: item.MstMenuId,
            ViewPermission: item.checked?.[0]?.view ? 1 : 0,
            AddPermission: item.checked?.[0]?.add ? 1 : 0,
            ModifyPermission: item.checked?.[0]?.edit ? 1 : 0,
            DeletePermission: item.checked?.[0]?.delete ? 1 : 0,
            InActivePermission: item.checked?.[0]?.inActive ? 1 : 0,
            ProvideServicePermission: item.checked?.[0]?.service ? 1 : 0,
            CreatedBy: 0,
          });
        }

        // Process submenus if available
        if (item.SubMenu && item.SubMenu.length > 0) {
          item.SubMenu.forEach((submenu) => {
            if (submenu.MstMenuId !== null) {
              convertedMenuData.push({
                MstRoleId: handleRoleChange,
                MstMenuHeadingId:
                  submenu.MstMenuHeadingId || item.MstMenuHeadingId,
                MstMenuId: submenu.MstMenuId,
                ViewPermission: submenu.checked?.view ? 1 : 0,
                AddPermission: submenu.checked?.add ? 1 : 0,
                ModifyPermission: submenu.checked?.edit ? 1 : 0,
                DeletePermission: submenu.checked?.delete ? 1 : 0,
                InActivePermission: submenu.checked?.inActive ? 1 : 0,
                ProvideServicePermission: submenu.checked?.service ? 1 : 0,
                CreatedBy: 0,
              });
            }
          });
        }
      });
    });

    return convertedMenuData;
  };
  useEffect(() => {
    if (partnerBulkUploadData) {
      // make sure data is not null or undefined
      const convertedMenuData = convertOrganizedMenuData(
        partnerBulkUploadData,
        3
      );
      setPartnerBulkUploadDataNew(convertedMenuData);
    }
  }, [partnerBulkUploadData]);
  return (
    <div class="w-full">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div class=" flex flex-col w-full">
        <div class={mainTable.clientMasterMainAdd}>
          <div class={mainTable.addShadowScreenpopup}>
            <div class={mainTable.mainContentScreen}>
              <form class={mainTable.formForClientMaster}>
                <div class={mainTable.grid2}>
                  <InputText
                    inputType={"text"}
                    title={"Partner Name"}
                    name={"partnerName"}
                    classStar={"text-red-500"}
                    maxLength={100}
                    placeholder="Enter Name Of Your Organization"
                    content={partnerFields.partnerName}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        partnerName: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        partnerNameError:
                          partnerFields.partnerName &&
                            partnerFields.partnerName.length > 0

                            ? ""
                            : partnerFields.partnerName.length < 3
                              ? "Minimum 3 characters required"
                              : partnerFields.partnerName.length > 200
                                ? "Maximum 200 characters allowed"

                                : "Enter Partner Name",
                      }));
                    }}
                    errorMessage={partnerFieldsError.partnerNameError}

                  />
                  <InputText
                    inputType={"text"}
                    title={"Full Address"}
                    maxLength={500}
                    name={"address"}
                    classStar={"text-red-500"}
                    content={partnerFields.address}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        address: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        addressError:
                          partnerFields.address &&
                            partnerFields.address.trim().length > 0

                            ? ""
                            : "Enter full address",
                      }));
                    }}
                    errorMessage={partnerFieldsError.addressError}

                  />
                  <AutoDropDown
                    title="Country"
                    options={countryBindDD}
                    placeholder="Select"
                    name="country"
                    selectedOption={countryBindDD.find(
                      (x) => x.value == partnerFields.country
                    )}
                    Class="custom-class"
                    tabIndex="1"
                    classStar="text-red-500"
                    controlFunc={(value, e) => {
                      handlePartnerFieldsChange(value.value, e.name);
                    }}
                    controlFuncBlur={() => {
                      setPartnerFieldsError(() => ({
                        ...partnerFieldsError,
                        countryError: partnerFields.country
                          ? ""
                          : "Select Country",
                      }));
                    }}
                    errorMessage={partnerFieldsError.countryError}

                  />

                  <InputText
                    inputType="text"
                    title="State"
                    name="state"
                    maxLength={100}
                    content={partnerFields.state}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        state: e.target.value,
                      })
                    }

                  />


                  <InputText
                    inputType="text"
                    title="City"
                    name="city"
                    maxLength={100}
                    content={partnerFields.city}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        city: e.target.value,
                      })
                    }

                  />
                  <InputText
                    inputType={"text"}
                    title={"Pin Code"}
                    name={"pinCode"}
                    maxLength={15}
                    content={partnerFields.pinCode}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        pinCode: e.target.value,
                      })
                    }


                  />
                  <InputText
                    inputType={"text"}
                    title={"GST No. (Put NA if not applicable)"}
                    maxLength={100}
                    name={"gst"}
                    classStar={"text-red-500"}
                    content={partnerFields.gst}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        gst: e.target.value,
                      })
                    }
                    controlFuncBlur={() => {
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        gstError:
                          partnerFields.gst && partnerFields.gst.trim().length > 0
                            ? ""
                            : "Enter GST",
                      }));
                    }}
                    errorMessage={partnerFieldsError.gstError}
                  />

                </div>
                <div class={mainTable.label}>Contact Info</div>
                <hr class={mainTable.horizontalLine}></hr>
                <div class="grid gap-4 mb-6 md:grid-cols-2">
                  <InputText
                    inputType={"text"}
                    title={"First Name"}
                    name={"firstName"}
                    classStar={"text-red-500"}
                    maxLength={100}
                    content={partnerFields.firstName}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        firstName: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        firstNameError:
                          partnerFields.firstName &&
                            partnerFields.firstName.length > 0
                            ? ""
                            : partnerFields.firstName.length < 2
                              ? "Minimum 2 characters required"
                              : partnerFields.firstName.length > 100
                                ? "Maximum 100 characters allowed"
                                : "Enter First Name",
                      }));
                    }}
                    errorMessage={partnerFieldsError.firstNameError}

                  />
                  <InputText
                    inputType={"text"}
                    title={"Last Name"}
                    name={"lastName"}
                    classStar={"text-red-500"}
                    maxLength={100}
                    content={partnerFields.LastName}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        LastName: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      const trimmedLastName =
                        partnerFields.LastName?.trim() || "";

                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        LastNameError:
                          trimmedLastName.length > 0
                            ? ""
                            : trimmedLastName.length > 100
                              ? "Maximum 100 characters allowed"
                              : "Enter Last Name",
                      }));
                    }}
                    errorMessage={partnerFieldsError.LastNameError}

                  />
                  <InputText
                    inputType="text"
                    classStar={"text-red-500"}
                    title="Designation"
                    name="designation"
                    maxLength={100}
                    content={partnerFields.designation}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        designation: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      const value = partnerFields.designation?.trim();
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        designationError:
                          value && value.length > 0
                            ? ""
                            : "Enter Designation",
                      }));
                    }}
                    errorMessage={partnerFieldsError.designationError}
                  />
                  <InputText
                    inputType={"text"}
                    title={"Contact Number"}
                    name={"contactNumber"}
                    classStar={"text-red-500"}
                    maxLength={20}
                    content={partnerFields.contactNumber}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        contactNumber: e.target.value,
                      })
                    }
                    controlFuncBlur={(e) => {
                      setPartnerFieldsError((partnerFieldsError) => ({
                        ...partnerFieldsError,
                        contactNumberError:
                          partnerFields.contactNumber &&
                            partnerFields.contactNumber.length > 0

                            ? ""
                            : "Enter Contact Number",
                      }));
                    }}
                    errorMessage={partnerFieldsError.contactNumberError}

                  />
                  <InputText
                    inputType={"text"}
                    title={"Email"}
                    classStar={"text-red-500"}
                    name={"email"}
                    content={partnerFields.email}
                    controlFunc={(e) =>
                      setPartnerFields({
                        ...partnerFields,
                        email: e.target.value,
                      })
                    }
                    maxLength={150}
                    controlFuncBlur={(e) => {
                      setPartnerFieldsError((partnerFieldsError) => {
                        let emailError = "";

                        if (
                          !partnerFields.email ||
                          partnerFields.email.length === 0
                        ) {
                          emailError = "Enter Email";

                        } else if (
                          !updateScreenTitle &&
                          bindContactNoAndEmailDatas.find(
                            (x) =>
                              x.UserEmail.toLowerCase() ===
                              partnerFields.email.toLowerCase()
                          )
                        ) {
                          emailError = "Email address already available";
                        }

                        return {
                          ...partnerFieldsError,
                          emailError,
                        };
                      });
                    }}
                    errorMessage={partnerFieldsError.emailError}

                  />
                </div>
                <FileUpload
                  title="Logo"
                  apiCall="PartnerAPI/PartnerImageUpload"
                  modalName="PartnerLogo"
                  name="showImage"
                  clear={updateScreenTitle}
                  showImage={partnerFields.showImage}
                  showImageData={handleShowImage}
                  imageUploadedError={partnerFieldsError.showImageError}
                  imageShow={false}
                  limitMassage={
                    "Image size limit: 2 MB. Accepted Image types:jpg, png, jpeg."
                  }
                  MAX_FILE_SIZE_MB={2}
                  ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PartnerRegistration;
